export default __webpack_public_path__ + "static/media/logo.7b5cab8d.png";